import { datadogRum } from "@datadog/browser-rum";

export function initDatadog(): void {
  const applicationId = import.meta.env.VITE_DD_RUM_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DD_RUM_CLIENT_TOKEN;

  if (!applicationId || !clientToken) {
    // Not configured — local dev without SSM vars. Skip silently.
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: "us5.datadoghq.com",
    // Route RUM intake through our first-party Express proxy so ad-blockers
    // (which block *.datadoghq.com) do not drop events. See STA-290.
    proxy: "/dd-rum",
    service: "stackverify-web",
    env: import.meta.env.VITE_DD_ENV || import.meta.env.MODE,
    version: import.meta.env.VITE_APP_VERSION || "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
  });
}
